var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 86,
    viewBox: "0 0 176 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.39006e-05 50.9062C1.39006e-05 50.9062 2.5301 34.3517 3.50275 27.1273C4.46557 19.9553 5.81299 8.70172e-06 5.81299 8.70172e-06C5.81299 8.70172e-06 51.2608 6.74738 73.7276 13.2962C86.4652 17.0091 127.2 23.5286 134.475 25.3317C141.751 27.1348 162.574 31.4717 165.393 32.0055C168.211 32.5393 175.128 33.2105 175.128 33.2105C175.128 33.2105 173.897 51.2947 172.384 57.3422C170.87 63.3896 169.726 74.5787 169.854 75.9278C169.982 77.2769 168.651 85.4005 168.651 85.4005C168.651 85.4005 119.513 76.0777 112.507 73.8475C105.502 71.6174 65.5789 66.2797 53.7229 62.8475C41.8669 59.4153 28.6542 57.129 17.3407 55.2036C6.02722 53.2782 1.39006e-05 50.9062 1.39006e-05 50.9062Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.7a1e293e4d56485a871448323e4c3cbd.svg";
export { ForwardRef as ReactComponent };